// React i hooks
import { memo, useCallback, useState } from "react";
import { useTranslate } from "helpers";

// UI komponente
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";

// Tipovi i konstante
import { ResidualValueSearchFormValues } from "services/api/calculations/residualvalue/types";
import { ResidualValueSearchFilterProps } from "./types";
import { initialResidualValueSearchForm } from "services/api/calculations/residualvalue/consts";

const ResidualValueSearchFilters: React.FC<ResidualValueSearchFilterProps> = (
  props
) => {
  const { onSearchChange, onAddNew } = props;

  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<ResidualValueSearchFormValues>(
    initialResidualValueSearchForm
  );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialResidualValueSearchForm);
  }, []);

  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center ">
          <div className="flex flex-wrap gap-3">
            <div className="">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder={t("admin.search.placeholder")}
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>

            <div className="mr-3 md:mr-6 lg:md-12 flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                {t("admin.reset")}
              </span>
            </div>
          </div>
          <div className="py-3 flex gap-2 justify-end ">
            <Button
              variant="primary"
              children={t("admin.calculation.setting.residualvalue.add")}
              startIcon="/media/icons/plus.svg"
              onClick={onAddNew}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(ResidualValueSearchFilters);
